module.exports = __webpack_public_path__ + "static/media/Garen.4218db4d.png";